/**
 * Nombres de los query params del puente builder. Constantes PURAS (sin DOM ni
 * `window`) para poder compartirlas entre el core (browser: `builder-token.ts`)
 * y el helper de servidor `veo-sdk/next` (`src/next.ts`), sin arrastrar código de
 * navegador al bundle de servidor.
 */

/** Token de correlación del handshake. */
export const BUILDER_TOKEN_PARAM = 'veoBuilder';
/** Origen del dashboard de Veo (para postMessage / frame-ancestors). */
export const BUILDER_ORIGIN_PARAM = 'veoBuilderOrigin';
/** `1` → modo "panel inyectado": la app es top-level y el editor se inyecta encima. */
export const BUILDER_PANEL_PARAM = 'veoBuilderPanel';
/** Path del panel del editor en el dashboard (default `/guides/design`). */
export const BUILDER_PANEL_PATH_PARAM = 'veoBuilderPanelPath';
/** Id de la guía que se está editando (para cargar/guardar en el panel). */
export const BUILDER_GUIDE_PARAM = 'veoGuide';
